import React from "react";
import { colors, radii, spacing } from "./theme";

export default function Badge({
  children,
  tone = "neutral",
  size = "md",
  style = {}
}) {
  const tones = {
    neutral: {
      background: colors.surfaceMuted,
      color: colors.textMuted,
      border: colors.border
    },
    success: {
      background: colors.successBg,
      color: colors.success,
      border: colors.successBg
    },
    warning: {
      background: colors.warningBg,
      color: colors.warning,
      border: colors.warningBg
    },
    danger: {
      background: colors.dangerBg,
      color: colors.danger,
      border: colors.dangerBg
    },
    info: {
      background: colors.infoBg,
      color: colors.info,
      border: colors.infoBg
    },
    primary: {
      background: colors.primaryLight,
      color: colors.primaryDark,
      border: colors.primaryLight
    }
  };

  const sizes = {
    sm: {
      padding: `${spacing.xs}px ${spacing.sm}px`,
      fontSize: 12
    },
    md: {
      padding: `${spacing.xs}px ${spacing.md}px`,
      fontSize: 13
    }
  };

  const selectedTone = tones[tone] || tones.neutral;
  const selectedSize = sizes[size] || sizes.md;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: radii.full,
        border: `1px solid ${selectedTone.border}`,
        fontWeight: 700,
        lineHeight: 1,
        background: selectedTone.background,
        color: selectedTone.color,
        ...selectedSize,
        ...style
      }}
    >
      {children}
    </span>
  );
}